import { FETCH_PENDING_REVIEWS, FETCH_PENDING_REVIEWS_ERROR, FETCH_PENDING_REVIEWS_SUCCESS } from './types';

const initialState = {
  items: [],
  loading: false,
  error: false,
};

const degreePlanningPlansReducer = (state = initialState, action) => {
  switch (action.type) {
    case FETCH_PENDING_REVIEWS:
      return { ...state, loading: true, error: false };
    case FETCH_PENDING_REVIEWS_SUCCESS:
      return { ...state, loading: false, items: Array.isArray(action.payload) ? action.payload : [] };
    case FETCH_PENDING_REVIEWS_ERROR:
      return { ...state, loading: false, error: true };
    default:
      return state;
  }
};

export default degreePlanningPlansReducer;
